import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const pollElement = css`
	.questionBody {
		.CodeMirror {
			height: auto;
			border: 1px solid ${colors.border};
			border-radius: 4px;
			padding: 6px 12px;
			font-size: 16px;
			font-family: inherit;
			color: ${colors.mainText};
		}
	}

	.choiceLabels {
		display: flex;
		justify-content: space-between;

		label:not(:first-child) {
			width: 200px;
		}
	}

	.addChoiceButton {
		margin-bottom: 10px;
		font-size: 14px;
		border: none;

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}

	.addDataBlock {
		display: flex;
		margin-bottom: 20px;
	}

	.addDataButton,
	.removeDataButton {
		font-size: 14px;
	}

	.chartTypeBlock {
		margin-bottom: 0;
		display: flex;
		align-items: center;
		margin-left: 20px;
		color: ${colors.mainText};

		label {
			margin-bottom: 0;
		}

		.form-check {
			margin-left: 15px;
		}
	}

	.dataSettings {
		display: flex;

		.form-group:not(:first-child) {
			margin-left: 20px;
		}
	}
`;

export const pollChoice = css`
	position: relative;

	.form-group {
		margin-bottom: 5px;
	}

	.choiceRow {
		display: flex;
		padding-right: 20px;
	}

	.choice {
		flex: 1;
		background-color: ${colors.background};
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding-left: 39px;

		input {
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
			border: none;
			border-left: 1px solid ${colors.border};
		}
	}

	.shortenedChoice {
		width: 180px;
		margin-left: 10px;
	}

	.deleteChoiceIcon {
		position: absolute;
		top: 0px;
		right: 0px;
		color: #ced4da;

		:hover {
			color: ${colors.hoverText};
		}
	}

	.charCount {
		margin-top: 0;
		margin-right: 20px;
		font-size: 10px;
		text-align: right;
	}

	.charCount.overflow {
		color: red !important;
	}
`;

export const pollDataTable = css`
	width: 100%;
	color: #757575;

	.cell > input {
		width: 100% !important;
		height: 100% !important;
	}

	.cell {
		padding: 3px 6px !important;
		word-break: break-word;
	}

	tr:first-child {
		height: 31px !important;
	}

	.addColumn {
		text-align: center;
		position: relative;
		padding: 0 12px;
		min-height: 24px;
	}

	.addButton {
		cursor: pointer;
		position: absolute;
		top: 4px;
		right: 2px;
	}
`;

export const contextualInfoStyle = css`
	display: flex;
	align-items: center;

	.contextualInfoInput {
		flex: 1;
		margin-left: 10px;
	}
`;

export const colorPaletteBlock = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	margin-bottom: 20px;

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 6px 12px;
		color: #757575;
		font-size: 14px;
	}

	.collapseIcon {
		cursor: pointer;
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		cursor: pointer;
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.body {
		padding: 12px;
		display: flex;
		justify-content: space-between;
		color: ${colors.mainText};

		.colorPalette {
			display: flex;
			align-items: baseline;
		}

		.colorPalette:last-child {
			margin-bottom: 0;
		}

		.colorRow {
			display: flex;
			flex-wrap: wrap;
			margin-left: 15px;
		}

		.colorBox {
			width: 16px;
			height: 16px;
			border-radius: 3px;
			box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;
		}

		.colorBox {
			margin-right: 5px;
			margin-bottom: 5px;
		}

		.colorsGroupBy {
			display: flex;
			align-items: baseline;

			label {
				text-wrap: nowrap;
				margin-right: 10px;
			}

			select {
				min-width: 200px;
			}
		}

		.clearSelectionButton {
			border-color: ${colors.border};

			:hover {
				color: ${colors.mainText};
				border-color: ${colors.border};
				background-color: ${colors.background};
			}
		}
	}
`;

export const pollChartPreview = css`
	display: flex;
	flex-direction: column;

	.sampleDataToggle {
		align-self: end;
		color: ${colors.mainText};
		font-size: 14px;
	}
`;
